module.exports = __webpack_public_path__ + "static/assets/def0a1ed00097044fb62db8a0f86c4c9.png";